import React from "react";
import CreatedByFilter from "./CreatedByFilter";

const normalizeStatusKey = (label = "") => {
  const l = String(label || "").trim().toLowerCase();
  if (!l || l === "all") return "all";
  if (l === "wip" || l === "in progress" || l === "in-progress") return "wip";
  return l.replace(/\s+/g, "_");
};

const TaskStatusFilterRow = ({
  statusSummary = [],
  currentStatus = "All",
  onStatusFilter,
  tasks = [],
  statusCounts = null,
  isApplying = false,
  createdByCreators = [],
  selectedCreatedByUserId = null,
  currentUserId = null,
  onCreatedBySelect,
}) => {
  const getStatusCount = (label) => {
    const apiCounts = statusCounts && typeof statusCounts === "object" ? statusCounts : null;
    if (apiCounts) {
      const normalizedCounts = {};
      Object.keys(apiCounts).forEach((key) => {
        normalizedCounts[key.toLowerCase()] = apiCounts[key];
      });

      if (label === "All") {
        return statusSummary
          .filter((card) => card.label !== "All")
          .reduce((sum, card) => sum + Number(normalizedCounts[normalizeStatusKey(card.label)] || 0), 0);
      }
      return Number(normalizedCounts[normalizeStatusKey(label)] || 0);
    }
    return tasks.filter((t) => label === "All" || (t.status || "Pending") === label).length;
  };

  return (
    <div className="status-pills-row">
      <div className="status-pills-group">
        {statusSummary.map((card) => (
          <button
            key={card.label}
            type="button"
            className={`status-pill${currentStatus === card.label ? " active" : ""}${isApplying ? " disabled-pill" : ""}`}
            onClick={() => !isApplying && onStatusFilter && onStatusFilter(card.label)}
          >
            {card.label} <span className="status-pill-count">{getStatusCount(card.label)}</span>
          </button>
        ))}
      </div>
      {onCreatedBySelect && currentUserId && (
        <CreatedByFilter
          creators={createdByCreators}
          selectedUserId={selectedCreatedByUserId}
          currentUserId={currentUserId}
          onSelect={onCreatedBySelect}
          disabled={isApplying}
        />
      )}
    </div>
  );
};

export default TaskStatusFilterRow;
